import { Button, IconButtonProps, Tooltip } from '@chakra-ui/react';

type Props = {
  label?: string

} & Partial<IconButtonProps>

const GenericDataTableBtn: React.FC<Props> = ({ label, 
  ...rest
}) => {
  return (
    <Tooltip
      hasArrow
      label={`${label || 'Details'} of record`}
      placement="auto"
      aria-label={`${label || 'Details'} button tooltip`}
    >
      <Button
        size={'md'}
        mr={'1rem'}
        {...rest}
        aria-label={`DataTable row ${label || 'Details'}`}
      >
        {label || 'Détail'}
      </Button>
    </Tooltip>
  );
};

export default GenericDataTableBtn;
